import "./AboutContentStyles.css"

import React from 'react'


import About1 from "../assets/about.jpg"

import About2 from "../assets/about_2.jpg"
import { useTranslation } from "react-i18next"


const AboutContent = () => {
    const { t } = useTranslation();
  return (
    <section className="about-section" id="about-section">
        <div className="about-container">
            <h1 className="about-heading">{t('about.title')}</h1>
            <hr className="small-hr"></hr>
            <div className="about-card">
                <div className="left">
                    <div className="img-container">
                        <div className="img-stack top">
                            <img src={About1} className="img" alt="true" />
                        </div>
                        <div className="img-stack bottom">
                            <img src={About2} className="img" alt="true" />
                        </div>
                    </div>
                </div>
                <div className="right">
                    <p>{t('about.part1')}</p>

                    <p>{t('about.part2')}</p>

                    <p>{t('about.part3')}</p>
                </div> 
            </div>         
        </div>
    </section>
  )
}

export default AboutContent